(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["imagix-story-library"] && !Shopify.designMode) return;
  try {
    
(() => {
  const openLinkedStory = () => {
    let storyId;
    try { storyId = decodeURIComponent(window.location.hash.slice(1)); } catch { return; }
    if (!storyId) return;
    const story = document.getElementById(storyId);
    if (story && story.matches('.ix-stories__story')) {
      story.open = true;
      story.scrollIntoView({ block: 'start', behavior: 'instant' });
    }
  };
  window.addEventListener('hashchange', openLinkedStory);
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', openLinkedStory, { once: true });
  } else {
    openLinkedStory();
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["imagix-storytime"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('imagix-storytime')) {
  customElements.define('imagix-storytime', class extends HTMLElement {
    connectedCallback() {
      if (this.storytimeClick) return;
      this.storytimeClick = (event) => {
        const card = event.target.closest('[data-storytime-prompt]');
        if (!card || !this.contains(card)) return;
        const output = this.querySelector('[data-storytime-active-prompt]');
        if (!output) return;
        this.querySelectorAll('[data-storytime-prompt]').forEach((button) => {
          button.setAttribute('aria-pressed', String(button === card));
        });
        output.textContent = card.dataset.storytimePrompt;
      };
      this.addEventListener('click', this.storytimeClick);
    }
    disconnectedCallback() {
      if (this.storytimeClick) this.removeEventListener('click', this.storytimeClick);
      this.storytimeClick = null;
    }
  });
}

  } catch(e) { console.error(e); }
})();
})();
